import Component from './ColumnChooserBody.component';

export default Component;
